
<template>
  <el-select-v2
    v-model="selectedValues"
    multiple
    collapse-tags
    collapse-tags-tooltip
    :placeholder="placeholder"
    style="width: 100%"
    :disabled="disabled"
    :options="allOptions"
    :value-key="valueKey"
    :label-key="labelKey"
  >
<template #default="{ item }">
  <div class="option-row" @click.stop="toggleItem(item[valueKey])">
    <el-checkbox
      :model-value="selectedValues.includes(item[valueKey])"
    />
    <span>{{ item[labelKey] }}</span>
  </div>
</template>


    <!-- تگ بالای select -->
    <template #tag>
      <span>{{ displayText }}</span>
    </template>
  </el-select-v2>
</template>

<script setup>
import { computed } from "vue";
import { ElSelectV2, ElCheckbox } from "element-plus";

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Array,
    default: () => [],
  },
  valueKey: {
    type: String,
    required: true,
  },
  labelKey: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: "",
  },
  multiText: {
    type: String,
    default: "چندین آیتم",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  includeAll: { // اضافه کردن گزینه همه
    type: Boolean,
    default: false,
  },
  allLabel: {
    type: String,
    default: "همه",
  },
  allValue: {
    type: [String, Number],
    default: "all",
  },
});

const emit = defineEmits(["update:modelValue"]);

const selectedValues = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

// اضافه کردن گزینه "همه"
const allOptions = computed(() => {
  if (!props.includeAll) return props.options;
  return [{ [props.valueKey]: props.allValue, [props.labelKey]: props.allLabel }, ...props.options];
});

// متن نمایش داده شده روی select (تگ‌ها)
const displayText = computed(() => {
  if (!selectedValues.value.length) return "";
  if (selectedValues.value.length > 1) return props.multiText;
  const item = allOptions.value.find(
    (opt) => opt[props.valueKey] === selectedValues.value[0]
  );
  return item ? item[props.labelKey] : "";
});

// انتخاب / لغو انتخاب یک آیتم
const toggleItem = (value) => {
  let newVal = [...props.modelValue]; // استفاده از props.modelValue

  if (value === props.allValue) {
    const allOptionValues = props.options.map(opt => opt[props.valueKey]);
    if (newVal.includes(props.allValue)) {
      newVal = [];
    } else {
      newVal = [props.allValue, ...allOptionValues];
    }
  } else {
    if (newVal.includes(value)) {
      newVal = newVal.filter(v => v !== value);
      newVal = newVal.filter(v => v !== props.allValue);
    } else {
      newVal.push(value);
      const allOptionValues = props.options.map(opt => opt[props.valueKey]);
      if (allOptionValues.every(v => newVal.includes(v)) && props.includeAll) {
        newVal.push(props.allValue);
      }
    }
  }

  emit('update:modelValue', newVal); // فقط emit
};


</script>

<style scoped>
.option-row {
  display: flex;
  align-items: center;
  gap: 8px;
  direction: rtl; /* راست‌چین متن و چک‌باکس */
  width: 100%;
  cursor: pointer;
}


/* ردیف چک‌باکس + متن */
:deep(.option-row) {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* با rtl همه بچسبن سمت راست */
  gap: 6px;
  padding: 0 !important;
  margin: 0 !important;
  
}

/* خود چک‌باکس */
:deep(.option-row .el-checkbox) {
  margin: 0 !important;
  padding: 0 !important;
}

/* حذف فاصله داخلی label چک‌باکس */
:deep(.option-row .el-checkbox__label) {
  padding: 0 !important;
  margin: 0 !important;
}
.el-select-dropdown__item {
  padding: 0 !important;
}
::v-deep(.el-select-dropdown__item ){
  padding: 0 !important;
}
</style>
